// ----------------- Size Chart ----------------------
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.size-guide-open').forEach(function (openButton) {
    openButton.addEventListener('click', function () {
      const productBlock =
        openButton.closest('.selector-wrapper') ||
        openButton.closest('.product-detail__form__options') ||
        openButton.closest('.product__block') ||
        openButton.parentElement;

      let modal = null;

      if (productBlock) {
        modal = productBlock.querySelector('.size-guide-modal');
      }

      if (!modal) {
        modal = document.querySelector('.size-guide-modal');
      }

      if (modal) {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      }
    });
  });

  document.querySelectorAll('.size-guide-close').forEach(function (closeButton) {
    closeButton.addEventListener('click', function () {
      const modal = closeButton.closest('.size-guide-modal');

      if (modal) {
        modal.hidden = true;
        document.body.style.overflow = '';
      }
    });
  });

  document.querySelectorAll('.size-guide-modal').forEach(function (modal) {
    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        modal.hidden = true;
        document.body.style.overflow = '';
      }
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('.size-guide-modal').forEach(function (modal) {
        if (!modal.hidden) {
          modal.hidden = true;
          document.body.style.overflow = '';
        }
      });
    }
  });

  document.querySelectorAll('.sg-tab-button').forEach(function (button) {
    button.addEventListener('click', function () {
      const tabId = button.dataset.tab;
      const wrapper = button.closest('.size-guide-modal-box');

      if (!wrapper) return;

      wrapper.querySelectorAll('.sg-tab-button').forEach(function (btn) {
        btn.classList.remove('active');
      });

      wrapper.querySelectorAll('.sg-tab-content').forEach(function (content) {
        content.hidden = true;
        content.classList.remove('active');
      });

      button.classList.add('active');

      const activeContent = wrapper.querySelector('#' + tabId);

      if (activeContent) {
        activeContent.hidden = false;
        activeContent.classList.add('active');
      }
    });
  });

  document.querySelectorAll('.unit-button').forEach(function (button) {
    button.addEventListener('click', function () {
      const unit = button.dataset.unit;
      const wrapper = button.closest('.size-guide-right');

      if (!wrapper) return;

      wrapper.querySelectorAll('.unit-button').forEach(function (btn) {
        btn.classList.remove('active');
      });

      button.classList.add('active');

      const inchTable = wrapper.querySelector('.inch-table');
      const cmTable = wrapper.querySelector('.cm-table');

      if (unit === 'inch') {
        if (inchTable) inchTable.hidden = false;
        if (cmTable) cmTable.hidden = true;
      }

      if (unit === 'cm') {
        if (inchTable) inchTable.hidden = true;
        if (cmTable) cmTable.hidden = false;
      }
    });
  });
});
// ----------------- Size Chart ----------------------
